import localeText from '@/locales/datagrid'
import { SxProps, Theme } from '@mui/material'
import { useEffect } from 'react'
import FilterModelPro, {
    GridFilterItemPro,
    GridFilterModelPro,
    OperatorValue,
} from '../utils/filterModelPro'
import { GridColDefPro } from '../utils/types'
import FilterPanelSelect from './PanelSelect'

export default function FieldOperator({
    column,
    onFilterModelChange,
    item,
    sx,
}: {
    column: GridColDefPro
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    sx?: SxProps<Theme>
}) {
    const operators = FilterModelPro.getOperators(column.type)
    const operatorValue = item.operatorValue ?? ''

    useEffect(() => {
        if (
            !operators
                .map(o => o.value as string)
                .includes(item.operatorValue as string)
        ) {
            onFilterModelChange(prev => ({
                ...prev,
                items: prev.items.map(p =>
                    p.id === item.id
                        ? {
                              ...p,
                              operatorValue: FilterModelPro.getDefaultOperator(
                                  column.type,
                              ),
                          }
                        : p,
                ),
            }))
        }
    }, [operators])

    return (
        <FilterPanelSelect
            label={localeText.filterPanelOperator}
            name="_operador"
            value={operatorValue}
            options={operators as any}
            sx={sx}
            onChange={e => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id
                            ? {
                                  ...p,
                                  operatorValue: e.target
                                      .value as OperatorValue,
                              }
                            : p,
                    ),
                }))
            }}
        />
    )
}
